import React, { useEffect, useState } from "react";
import ErrorBoundary from "./ErrorBoundary";
import NetworkStatus from "./NetworkStatus";
import ErrorPage from "./ErrorPage";

const ErrorHandler = ({ children }) => {
  const [apiError, setApiError] = useState(null);

  useEffect(() => {
    const handleServerError = (event) => {
      setApiError({
        type: "server",
        status: event.detail?.status,
      });
    };

    const handleNetworkError = () => {
      setApiError({
        type: "network",
      });
    };

    const handleOffline = () => {
      setApiError({
        type: "network",
      });
    };

    const handleOnline = () => {
      setApiError(null);
    };

    // Catch global JavaScript errors
    const handleGlobalError = (event) => {
      console.error("Global Application Error:", event.error);

      setApiError({
        type: "app",
      });
    };

    // Catch unhandled Promise errors
    const handleUnhandledRejection = (event) => {
      console.error(
        "Unhandled Promise Rejection:",
        event.reason
      );

      setApiError({
        type: "app",
      });
    };

    window.addEventListener("api-server-error", handleServerError);
    window.addEventListener("api-network-error", handleNetworkError);

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    window.addEventListener("error", handleGlobalError);
    window.addEventListener(
      "unhandledrejection",
      handleUnhandledRejection
    );

    return () => {
      window.removeEventListener(
        "api-server-error",
        handleServerError
      );

      window.removeEventListener(
        "api-network-error",
        handleNetworkError
      );

      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);

      window.removeEventListener("error", handleGlobalError);

      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection
      );
    };
  }, []);

  if (apiError) {
    return (
      <ErrorPage
        type={apiError.type}
        status={apiError.status}
        onRetry={() => window.location.reload()}
      />
    );
  }

  return (
    <ErrorBoundary>
      <NetworkStatus>
        {children}
      </NetworkStatus>
    </ErrorBoundary>
  );
};

export default ErrorHandler;